import React from 'react';
import { SimpleForm } from 'react-admin';
import SectionedFormLayout from './SectionedFormLayout';

/**
 * A form component that combines react-admin's SimpleForm with SectionedFormLayout
 * @param {Object} props
 * @param {Array} props.sections - Array of section objects with title and fields
 * @param {Object} props.toolbar - Form toolbar component
 * @param {Object} props.formProps - Additional props to pass to SimpleForm
 */
const SectionedForm = ({ sections = [], toolbar, ...formProps }) => {
    return (
        <SimpleForm toolbar={toolbar} {...formProps}>
            <SectionedFormLayout sections={sections} />
        </SimpleForm>
    );
};

export default SectionedForm;
